<template>
  <Popup :showPopup="showDispositionPop" header="Call Outcomes" @close-popup="closePop()">
    <template v-slot:content>
      <div v-if="!showConfirm">
        <CheckboxWrap v-for='option in callCenterOutcomes' :inputID="option.Id" :labelText="option.OutcomeText" :key="option.Id">
          <template v-slot:input>
            <input :id='option.Id' v-model='optionsSelected' type='checkbox' :value='option'>
          </template>
        </CheckboxWrap>
      </div>
      
      <div v-if="showConfirm">
        <p v-if="alreadyReviewed">Call outcome information has already been provided for this call.</p>
        <div v-else>
          <label>You successfully added:</label>
          <ul v-for="(option, index) in optionsSelectedDispositions" :key="index">
            <li>{{ option }}</li>
          </ul>
        </div>
      </div>
    </template>

    <template v-slot:buttons v-if="!showConfirm">
      <button :disabled="!saveEnabled" @click="saveDisposition()">Save</button>
      <p class="error" v-if="error">An error has occured. Please save again.</p>
    </template>
  </Popup>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment-timezone';
import axios from 'axios';
import Popup from '@/components/Popup';
import CheckboxWrap from '@/components/CheckboxWrap';

export default {
  name: 'DispositionPopup',
  props: ['showDispositionPop', 'messageindex', 'callid', 'callCenterOutcomes'],
  components: { Popup, CheckboxWrap },
  computed: {
    ...mapState({
      calling: state => state.calling,
      user: state => state.user,
      call (state) {
        return state.currentMessages[this.messageindex]
      }
    }),
    saveEnabled: function () {
      return this.optionsSelected.length ? true : false;
    },
    optionsSelectedDispositions: function () {
      let selectedOutcomes = this.callCenterOutcomes.filter(outcome => {
        if (this.optionsSelected.map(option => option.Id).indexOf(outcome.Id) !== -1) {
          return true;
        }
      }).map( (outcome) => {
        return outcome.OutcomeText;
      });

      this.dispositionComplete(selectedOutcomes.join(', '));

      return selectedOutcomes;
    }
  },
  data: function () {
    return {
      optionsSelected: [],
      showConfirm: false,
      error: false,
      alreadyReviewed: false
    }
  },
  watch: {
    alreadyReviewed: function () {
      var that = this;
      setTimeout(function(){ that.closePop()}, 3000);
    }
  },
  methods: {
    closePop: function () {
      this.$emit('closingDisposition');
    },
    dispositionComplete: function (outcomeString) {
      this.$emit('dispositionComplete', outcomeString);
    },
    checkIfCallHasPreviousOutcome: async function () {
      return new Promise ( async (resolve, reject) => {
        try {
          const callid = this.call.callid;

          const endpoint = `callcenterOutcome/${callid}/outcome`;
          const res = await axios.get(endpoint);

          return res.data === true ? resolve(true) : resolve(false);
        } catch (err) {
          reject(err);
        }
      })
    },
    saveDisposition: async function() {
      if (this.saveEnabled) {
        const callHasPreviousOutcome = await this.checkIfCallHasPreviousOutcome();

        if (callHasPreviousOutcome === false) {
          const callid = this.call.callid;
          const optionIds = this.optionsSelected.map(option => option.Id);

          const endpoint = `callcenterOutcome/${callid}`;
          const res = await axios.post(endpoint, {
            leuserid: this.user.leuserid,
            datetime: moment().tz('America/Chicago').toISOString(true),
            outcomes: optionIds
          })

          if (res.status === 201) {
            this.$emit('sending');
            this.showConfirm = true;
          } else {
            this.error = true;
          }
        } else {
          this.$emit('sending');
          this.showConfirm = true;
          this.alreadyReviewed = true;
        }
      }
    }
  }
}
</script>